import { ComponentStyleConfig } from '@chakra-ui/react';
import { z } from 'zod';

const propsSchema = z.object({
  isDisabled: z.boolean().default(false),
  isDragActive: z.boolean().default(false),
  isFocused: z.boolean().default(false),
  isLoading: z.boolean().default(false),
  size: z.enum(['xs', 'sm', 'md', 'lg']).default('md'),
});

const withKnownProps =
  <T>(f: (props: z.output<typeof propsSchema>) => T) =>
  (props: unknown) =>
    f(propsSchema.parse(props));

export const FileUploadBoxStyles: ComponentStyleConfig = {
  parts: ['dropzone', 'listItem'],
  baseStyle: withKnownProps((props) => {
    const cursor = props.isDisabled
      ? 'not-allowed'
      : props.isLoading
        ? 'initial'
        : 'pointer';

    return {
      dropzone: {
        display: 'flex',
        px: 2,
        bg: 'layer.1',
        border: `${props.isDragActive ? 'dashed' : 'solid'} 1px`,
        borderColor: 'border.1',
        outlineWidth: '2px',
        outlineColor: 'state.selected',
        outlineOffset: '1px',
        borderRadius: '4px',
        color: 'text.link',
        cursor,
        opacity: props.isDisabled ? 0.5 : 1,
        _hover: {
          borderColor: props.isDragActive ? undefined : 'state.selected',
          textDecoration: 'underline',
        },
      },
      listItem: {
        py: 1,
        px: `calc(var(--chakra-space-2) - 1px)`,
        bg: 'layer.1',
        borderRadius: '4px',
        border: 'solid 1px',
        borderColor: 'border.1',
      },
    };
  }),
  sizes: {
    xs: {
      dropzone: {
        gap: 1,
        py: `calc(var(--chakra-space-1) - 1px)`,
      },
    },
    sm: {
      dropzone: {
        gap: 1,
        py: `calc(var(--chakra-space-1-5) - 1px)`,
      },
    },
    md: {
      dropzone: {
        minHeight: 24,
        gap: 2,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        py: 2,
      },
    },
    lg: {
      dropzone: {
        gap: 2,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        py: `calc(var(--chakra-space-9) + 1px)`,
      },
    },
  },
};
